import { getOwner } from '@ember/owner';
import application from 'volta/utils/application';
import type Model from '@ember-data/model';
import type ApplicationInstance from '@ember/application/instance';
import type StoreService from 'volta/services/store';
import type { Snapshot } from '@ember-data/legacy-compat/legacy-network-handler/snapshot';

/**
 * Given a record, obtain the ember-data model class
 * @param record
 */
export function _getModelClass<M extends typeof Model>(record: InstanceType<M>): M {
  return record.constructor as M;
}

/**
 * Given an ember-data model class, obtain its name
 * @param clazz
 */
export function _getModelName(clazz: typeof Model): string {
  return clazz.modelName;
}


/**
 * Given an ember-data-record, obtain the related Store
 * @param record
 */
export function _getStoreFromRecord(record: Model) {
  const owner = getOwner(record) as ApplicationInstance;
  return owner.lookup('service:store') as StoreService;
}

/**
 * Lookup and return the application wide store
 */
export function _getStore() {
  return application.instance?.lookup('service:store') as StoreService;
}

/**
 * Given an ember-data-model, obtain the related snapshot
 * @param model
 */
export function _snapshotFromRecord(model: Model): Snapshot {
  return (model as any)._createSnapshot();
}
